import React from "react";
import { DataTable } from "best-common-react";
import { LineupTableStyled } from "../../elements/LineupTableStyled";
import styled from "styled-components";

const TWPhighlightStyle = styled.div.attrs(() => ({}))`
  color: black;
  background-color: yellow;
  font-weight: bold;
  font-size: 14px;
`;

const PitcherNumberFormatter = ({ row }) => {
  return <div style={{ fontWeight: "bold", fontSize: "18px" }}>{row?.twp ? "" : row.pitcherCount}</div>;
};

const PitchersNameFormatter = ({ row }) => {
  const displayName = row?.displayName || row?.lastName + ", " + row.preferredName?.substring(0, 1);
  return (
    <div className="d-flex justify-content-between">
      <div style={{ fontSize: "14px" }}>{displayName}</div>
      {row?.twp && <TWPhighlightStyle>TWP</TWPhighlightStyle>}
    </div>
  );
};

const Columns = [
  {
    key: "pitcherCount",
    name: "",
    width: 40,
    formatter: PitcherNumberFormatter
  },
  {
    key: "name",
    name: "Pitchers",
    formatter: PitchersNameFormatter
  }
];

const PitchersTable = ({ pitchers = [] }) => {
  return (
    <LineupTableStyled>
      <DataTable columns={Columns} data={pitchers} height={440} rowHeight={40} minColumnWidth={100} />
    </LineupTableStyled>
  );
};

export default PitchersTable;
